(function () {
  'use strict';

  if (window.HanogramNativeUpsellLoaded) return;
  window.HanogramNativeUpsellLoaded = true;

  var widgetSelector = '[data-hanogram-native-upsell]';

  function setSelected(card, selected) {
    var toggle = card.querySelector('[data-upsell-toggle]');
    var quantity = card.querySelector('[data-upsell-quantity]');
    card.classList.toggle('is-selected', selected);
    card.dataset.selected = selected ? 'true' : 'false';
    if (toggle) {
      toggle.hidden = selected;
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
    if (quantity) quantity.hidden = !selected;
  }

  function updateVariant(select) {
    var card = select.closest('[data-upsell-card]');
    var option = select.options[select.selectedIndex];
    if (!card || !option) return;

    var price = card.querySelector('[data-upsell-price]');
    var comparePrice = card.querySelector('[data-upsell-compare-price]');
    var image = card.querySelector('.hanogram-native-upsell__image');
    if (price) price.textContent = option.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.hidden = !option.dataset.comparePrice;
    }
    if (image && option.dataset.image) {
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
    }
  }

  function changeQuantity(card, amount) {
    var output = card.querySelector('[data-upsell-quantity-value]');
    if (!output) return;
    var next = Math.max(0, Math.min(99, Number(output.textContent) + amount));
    if (next === 0) {
      output.textContent = '1';
      setSelected(card, false);
      return;
    }
    output.textContent = String(next);
  }

  function formItem(form) {
    var formData = new FormData(form);
    var item = {
      id: Number(formData.get('id')),
      quantity: Math.max(1, Number(formData.get('quantity')) || 1)
    };
    var properties = {};

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });

    if (Object.keys(properties).length) item.properties = properties;
    if (formData.get('selling_plan')) item.selling_plan = Number(formData.get('selling_plan'));
    return item;
  }

  function selectedUpsells(widget) {
    return Array.prototype.map.call(
      widget.querySelectorAll('[data-upsell-card][data-selected="true"]'),
      function (card) {
        var select = card.querySelector('[data-upsell-variant]');
        var quantity = card.querySelector('[data-upsell-quantity-value]');
        return select ? { id: Number(select.value), quantity: Math.max(1, Number(quantity && quantity.textContent) || 1) } : null;
      }
    ).filter(Boolean);
  }

  function showError(widget, message) {
    var error = widget.querySelector('[data-upsell-error]');
    if (!error) return;
    error.textContent = message || widget.dataset.errorMessage;
    error.hidden = false;
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-upsell-variant]');
    if (select && select.closest(widgetSelector)) updateVariant(select);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-upsell-toggle]');
    if (toggle && toggle.closest(widgetSelector)) {
      setSelected(toggle.closest('[data-upsell-card]'), true);
      return;
    }

    var decrease = event.target.closest('[data-upsell-decrease]');
    if (decrease && decrease.closest(widgetSelector)) {
      changeQuantity(decrease.closest('[data-upsell-card]'), -1);
      return;
    }

    var increase = event.target.closest('[data-upsell-increase]');
    if (increase && increase.closest(widgetSelector)) {
      changeQuantity(increase.closest('[data-upsell-card]'), 1);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.tt-product-single-info .btn-addtocart');
    if (!button || button.classList.contains('disable')) return;

    var widget = document.querySelector(widgetSelector);
    var form = button.closest('form');
    if (!widget || !form) return;

    var accessories = selectedUpsells(widget);
    if (!accessories.length) return;

    var mainItem = formItem(form);
    if (!mainItem.id) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var error = widget.querySelector('[data-upsell-error]');
    if (error) error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [mainItem].concat(accessories) })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message);
          return data;
        });
      })
      .then(function (data) {
        var items = data.items || [];
        if (window.addToCartHandler && typeof window.addToCartHandler.addItem === 'function') {
          items.forEach(function (item) { window.addToCartHandler.addItem(item); });
        }
        var primaryItem = items.filter(function (item) {
          return Number(item.variant_id) === Number(mainItem.id);
        })[0] || items[0];
        if (primaryItem && window.addedModal && typeof window.addedModal.initSingleItem === 'function') {
          window.addedModal.initSingleItem(primaryItem);
        }
        if (window.Shopify && typeof window.Shopify.getCart === 'function') window.Shopify.getCart();
      })
      .catch(function (errorObject) {
        showError(widget, errorObject.message);
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  }, true);
})();
